import { render, staticRenderFns } from "./SubItemGroup.vue?vue&type=template&id=56a3953c&scoped=true"
import script from "./SubItemGroup.vue?vue&type=script&lang=js"
export * from "./SubItemGroup.vue?vue&type=script&lang=js"
import style0 from "./SubItemGroup.vue?vue&type=style&index=0&id=56a3953c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a3953c",
  null
  
)

export default component.exports